import {useContext} from "react";
import Context from "../context/Context";
import {Alert, Snackbar} from "@mui/material";

const SnackBarMessage = () => {
    const {snackbarSignal, hideSnackbar} = useContext(Context);

    return (
        <Snackbar open={snackbarSignal.show} autoHideDuration={5000} onClose={hideSnackbar}>
            <Alert onClose={hideSnackbar} severity={snackbarSignal.status} sx={{ width: '100%' }}>
                {snackbarSignal.message}
            </Alert>
        </Snackbar>
    );
};

export default SnackBarMessage;